<script>
import checkbox from '@/components/Main/Inputs/checkbox'

export default {
  name: "ContactPhone",
  components: {checkbox},
  props: {
    phone: {
      type: Object,
      default: () => ({})
    },
    phoneIndex: {
      type: Number,
      default: 0,
    },
    lastPhoneIndex: {
      type: Number,
      default: 0,
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      socials: [
        {
          key: 'whatsapp',
          title: 'WhatsApp'
        },
        {
          key: 'viber',
          title: 'Viber'
        },
        {
          key: 'telegram',
          title: 'Telegram'
        }
      ],
      openPhoneSetting: false,
    }
  },
  computed: {
    label() {
      return this.phoneIndex === 0 ? 'Phone' : '';
    },
  },
  methods: {
    removePhone() {
      this.$emit('removePhone', this.contactIndex);
    },
    addPhone() {
      this.$emit('addPhone');
    },
    openPhoneSettings() {
      this.openPhoneSetting = true;
    },
    closePhoneSettings() {
      this.openPhoneSetting = false;
    },
    setPhoneValue(e) {
      this.$set(this.phone, 'number', e.target.value)
    },
    checkboxPhone (data, item) {
      this.$set(this.phone, item, data)
    },
  }

}
</script>

<template>
  <div class="phone">
    <div
      v-if="editable"
      class="phone__item"
    >
      <label class="phone__label">{{label}}</label>
      <div class="phone__body">
        <input
          type="text"
          :value="phone.number"
          class="phone__input"
          autocomplete="off"
          @input="setPhoneValue"
        >
        <i class="icon-menu phone__phones-menu" @click.stop="openPhoneSettings"/>
        <transition name="bounce">
          <div
            v-if="openPhoneSetting"
            class="phone__social-menu-phones"
            @mouseleave="closePhoneSettings"
            v-click-outside="() => closePhoneSettings"
          >
            <div
              v-for="social in socials"
              :key="social.key + social.title"
              class="phone__social-menu-phone"
            >
              <checkbox
                :checkbox-text="social.title"
                :name="social.key"
                :value="phone[social.key]"
                @checkboxChange="checkboxPhone"
              />
            </div>
          </div>
        </transition>
      </div>
      <div
        v-if="phoneIndex !== lastPhoneIndex"
        class="phone__item-action"
        @click.stop="removePhone"
      >
        <i class="icon-minus phone__minus-icon"/>
      </div>
      <div
       v-else
        class="phone__item-action"
        @click.stop="addPhone"
      >
        <i class="icon-cross phone__add-icon"/>
      </div>
    </div>
    <div
      v-if="!editable && phone.number"
      class="phone__item"
    >
      <label class="phone__label">{{ label }}</label>
      <div class="phone__body is-show ">
        <div class="phone__text">
          {{ phone.number }}
          <div
            v-if="phone.whatsapp || phone.viber || phone.telegram"
            class="phone__social"
          >
                <span v-if="phone.whatsapp">
                  <i class="icon-whatsapp"/>
                </span>
            <span v-if="phone.viber" class="phone__viber-wrapper">
                  <i class="icon-viber-background"/>
                  <i class="icon-viber"/>
            </span>
            <span v-if="phone.telegram">
                  <i class="icon-telegram"/>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<style scoped lang="scss">
@import "../../../../../../sass/variables";

.phone {

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    column-gap: 12px;
  }

  &__label {
    align-self: flex-start;
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;
    color: $color-denim;
    min-width: 168px;
  }

  &__body {
    flex: 1 1 auto;
    min-height: 32px;
  }

  &__item-action {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid $color-seashell;
    box-sizing: border-box;
    border-radius: 5px;
    min-width: 30px;
    width: 30px;
    height: 30px;
    cursor: pointer;
  }

  &__add-icon {
    color: $color-denim;
    transform: rotate(45deg);
  }

  &__minus-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2px;
    color: $color-accent;
  }

  &__input {
    width: 100%;
    height: 30px;
    padding: 10px 30px 10px 7px;
    border: 1px solid $color-seashell;
    border-radius: 5px;
  }

  &__phones-menu {
    padding: 10px;
    position: absolute;
    transform: rotate(90deg);
    color: $color-denim;
    right: 45px;
    cursor: pointer;
  }
  &__social-menu-phones {
    position: absolute;
    top: 25px;
    right: 47px;
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 12px;
    background: $color-white;
    box-shadow: 0 0 20px rgba($color-black, 0.05);
    border-radius: 3px;
    z-index: 2;
  }

  &__social-menu-phone {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    user-select: none;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__text {
    text-align: right;
  }

  &__social {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
    color: $color-silver-chalice
  }

  &__viber-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
}

.icon-telegram {
  color: $color-accent-hover;
  font-size: 12px;
}

.icon-whatsapp {
  color: $color-mountain-meadow;
  font-size: 14px;
}

.icon-viber {
  position: relative;
  color: $color-white;
  font-size: 18px;
  z-index: 1;
}

.icon-viber-background {
  font-size: 16px;
  position: absolute;
  color: $color-wisteria;
}

</style>




// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactServiceProvider/ContactPhone.vue